import { PayableHistory } from 'components/PayableHistory'
import { useCallback } from 'react'
import { getAccountingVendorPayments } from 'services/apis/admin/accounting'
import { Modal } from 'stories/components'

import type { IAccountingVendor } from './types'

/** Everything paid to this vendor, across every loan — read-only, opened from the vendor list. */
export const VendorHistoryModal = ({
  vendor,
  childLevel = 2,
  onClose,
}: {
  vendor: IAccountingVendor
  childLevel?: number
  onClose: Function
}) => {
  const load = useCallback(() => getAccountingVendorPayments(vendor.id), [vendor.id])

  return (
    <Modal
      title={`Vendor History - ${vendor.name}`}
      titleOkay=""
      onClose={() => onClose()}
      childLevel={childLevel}
      isOpen
    >
      <div className="text-gray-900 w-[64rem] max-w-full">
        <PayableHistory load={load} />
      </div>
    </Modal>
  )
}
